export default {
  name: 'loudi',
  adcode: '431300',
  mapName: '娄底市',
  geoJsonPath: 'hunanmap/431300.json',
  backgroundImage: {
    png: '娄底市_431300.png',
    webp: '娄底市_431300.webp'
  },
  echartsMapStyle: {
    width: '903px',
    height: '658px',
    marginTop: 'auto',
    marginBottom: '93px',
  },
  imageSize: {
    width: 4166,
    height: 3038
  },
  // 地图特殊配置：背景图片适配参数
  specialConfig: {
    // 独立调整参数
    layoutSizeAdjustment: {
      enabled: true,
      multiplier: 1.36, // 布局尺寸调整倍数（微调）
      minSize: 400,     // 最小布局尺寸
      maxSize: 1200     // 最大布局尺寸
    },
    aspectScaleAdjustment: {
      enabled: true,
      multiplier: 1, // 宽高比调整倍数（微调）
      minScale: 0.5,    // 最小缩放比例
      maxScale: 2.0     // 最大缩放比例
    },
    // 位置偏移补偿
    positionOffset: {
      x: 0.004,  // X轴偏移百分比
      y: 0.005  // Y轴偏移百分比
    }
  },
  // 区县列表
  districts: ['娄底市区', '双峰县', '新化县', '冷水江市', '涟源市'],
  // 区县坐标映射（用于tooltip定位与涟漪效果）
  cityCoords: {
    // 市区参考坐标（用于兜底展示）
    '娄底市区': [111.988486, 27.696643],
    '娄底市': [111.988486, 27.696643],
    // 区县坐标（来自 431300.json center）
    '娄星区': [111.958486, 27.696643],
    '双峰县': [112.078245, 27.426126],
    '新化县': [111.186747, 27.917456],
    '冷水江市': [111.464674, 27.685759],
    '涟源市': [111.680847, 27.742301]
  },
  // 区县名称标准化
  normalizeName: (name) => {
    if (!name) return ''
    const s = String(name).trim()
    // 城区归并到“娄底市区”
    if (s === '娄底市' || s === '娄底市区') return '娄星区'
    return s
  },
  // 区县与adcode映射
  cityAdcodeMap: {
    '娄星区': '431302',
    '双峰县': '431321',
    '新化县': '431322',
    '冷水江市': '431381',
    '涟源市': '431382'
  }
}